export default {
    demo: false,
    brand: 'Abroad Michigan', // Footer brand
    appName: 'Abroad Chat', // App Name
    showCredits: true, // Show credits in login page
    url: 'https://iceschoolchat.abroadslab.com'
};
